import { Navigation } from "@/components/Navigation";
import { Card } from "@/components/ui/card";
import { MessageSquare, LifeBuoy, Headset } from "lucide-react";
import { Session } from "@supabase/supabase-js";

interface SupportProps {
  session: Session;
}

const Support = ({ session }: SupportProps) => {
  const supportOptions = [
    {
      title: "Chat Support",
      description: "Get instant help from our support team.",
      icon: MessageSquare,
    },
    {
      title: "Help Center",
      description: "Browse through our help articles and guides.",
      icon: LifeBuoy,
    },
    {
      title: "Contact Us",
      description: "Reach out to our customer service team.",
      icon: Headset,
    },
  ];

  return (
    <div className="min-h-screen bg-skuhub-navy">
      <Navigation session={session} />
      <div className="container mx-auto px-4 py-24">
        <h1 className="text-4xl font-bold text-white mb-8">Support</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {supportOptions.map((option) => (
            <Card key={option.title} className="p-6 bg-white/5 backdrop-blur-sm border-white/10">
              <div className="flex items-start space-x-4">
                <option.icon className="h-6 w-6 text-skuhub-coral" />
                <div>
                  <h3 className="text-lg font-semibold text-white">{option.title}</h3>
                  <p className="text-gray-400 mt-2">{option.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Support;
